import { createPropertySelectors, createSelector } from '@ngxs/store';

import {
  TakeOutDeliveryState,
  TakeOutDeliveryStateModel
} from './takeout-delivery.state';

export class TakeoutDeliverySelector {
  static slices =
    createPropertySelectors<TakeOutDeliveryStateModel>(TakeOutDeliveryState);

  static openTransactionTicketUuid = createSelector(
    [TakeoutDeliverySelector.slices.openTransactionTicketUuid],
    (openTransactionTicketUuid) => openTransactionTicketUuid
  );

  static enableTakeOutDelivery = createSelector(
    [TakeoutDeliverySelector.slices.enableTakeOutDelivery],
    (enableTakeOutDelivery) => enableTakeOutDelivery
  );

  static takeoutTickets = createSelector(
    [TakeoutDeliverySelector.slices.takeoutTickets],
    (tickets) => tickets
  );

  static ticketsLoaded = createSelector(
    [TakeoutDeliverySelector.slices.ticketsLoaded],
    (ticketsLoaded) => ticketsLoaded
  );

  static mealDeliveryAreaTimingsByDate = createSelector(
    [TakeoutDeliverySelector.slices.mdaTimingsByDate],
    (mdaTimingsByDate) => mdaTimingsByDate
  );
}
